import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { forwardRef } from 'react';

import styles from './CustomScrollbar.module.scss';
import React from 'react';

const cx = classnames.bind(styles);

const CustomScrollbar = forwardRef((
  {
    className,
    thumbYClassName,
    trackYClassName,
    children,
    autoHeightMax,
    ...props
  },
  ref
) => {
  return (
    <Scrollbars
      autoHide
      hideTracksWhenNotNeeded
      renderThumbVertical={(param) => (<div className={cx('thumb-vertical', thumbYClassName)} {...param} />)}
      renderTrackVertical={(param) => (<div className={cx('track-vertical', trackYClassName)} {...param} />)}
      className={cx('root', {'size-auto': !autoHeightMax}, className)}
      autoHeightMax={autoHeightMax || 5000}
      ref={ref}
      renderView={props => <div {...props} tabIndex="0" />}
      {...props}
    >
      { children }
    </Scrollbars>
  )
})

CustomScrollbar.propTypes = {
  className: PropTypes.string,
  thumbYClassName: PropTypes.string,
  trackYClassName: PropTypes.string,
}

CustomScrollbar.defaultProps = {
  className: '',
}

export default CustomScrollbar;
